import type { TFunction } from 'i18next'

import type { Entity, Role } from '../../../graphql/types'

interface EntityWithRole extends Entity {
  __typename?: 'Employee' | 'Doctor' | 'Clinic' | 'Patient'
  role?: Role
}
export function getEntityTitle(entity: EntityWithRole, t: TFunction) {
  switch (entity.__typename) {
    case 'Employee':
      return t(`role.${entity.role}`)
    case 'Doctor':
      return '醫生'
    case 'Patient':
      return '病患'
    case 'Clinic':
      return '診所'
    default:
      return ''
  }
}
